$(function() {
	
	// menu
	$('body').addClass('js');
	  var $menu = $('#menu'),
	  	  $menulink = $('.menu-link'),
	  	  $menulinkbutton = $('.menu-link i'),
	  	  $navsocial = $('.nav-social'),
	  	  $menuTrigger = $('.has-submenu > a');

	$menulink.click(function(e) {
		e.preventDefault();
		$menulink.toggleClass('active'); 
		$menu.toggleClass('active');
		$menulinkbutton.toggleClass('fa-times');
		$menulinkbutton.toggleClass('fa-bars');
	});

	$menuTrigger.click(function(e) {
		e.preventDefault();
		var $this = $(this);
		$this.toggleClass('active').next('ul').toggleClass('active');
	});



    $(".slides").responsiveSlides({
		auto: true,             		// Boolean: Animate automatically, true or false
		speed: 700,            			// Integer: Speed of the transition, in milliseconds
		timeout: 4000,          		// Integer: Time between slide transitions, in milliseconds
		pager: true,           		// Boolean: Show pager, true or false
		nav: true,             			// Boolean: Show navigation, true or false
		random: false,          		// Boolean: Randomize the order of the slides, true or false
		pause: false,           		// Boolean: Pause on hover, true or false
		pauseControls: true,    		// Boolean: Pause when hovering controls, true or false
		prevText: "Previous",   		// String: Text for the "previous" button
		nextText: "Next",       		// String: Text for the "next" button
		maxwidth: "",           		// Integer: Max-width of the slideshow, in pixels
		navContainer: "",       		// Selector: Where controls should be appended to, default is after the 'ul'
		manualControls: "",     		// Selector: Declare custom pager navigation
		namespace: "centered-btns",    	// String: Change the default namespace used
		before: function(){},   		// Function: Before callback
		after: function(){}     		// Function: After callback
	});
	
	// imgLiquid: https://github.com/karacas/imgLiquid
	$(".imgLiquidFill").imgLiquid({
		fill: true,
	    verticalAlign: 'center',     // 'center' //  'top'   //  'bottom' // '50%'  // '10%'
	    horizontalAlign: 'center',    // 'center' //  'left'  //  'right'  // '50%'  // '10%'
	});
	
});




